import React from "react";
import "../CSS/LoadingSpinner.css"; // Import the CSS for styling

const LoadingSpinner = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
